import { FullScreenImageDialogComponent } from '../dialogs/full-screen-image-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FileLoaderPipe } from '../../pipes/file-loader.pipe';
import { Component, inject, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PdfComponent } from '../pdf/pdf.component';
import { FileMapEntry, Resource } from 'common';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'lib-resource-viewer',
    standalone: true,
    imports: [PdfComponent, MatProgressSpinnerModule, MatButtonModule, MatIconModule, FileLoaderPipe, AsyncPipe],
    template: `
        @if(file() && file().contentUrl) {

            <!-- Fetch file from server. -->
            @if(file() | libLoadFile | async; as url) {

            <div class="resource-viewer-actions">
                <div class="actions-inner-container">
                    @if(showFullScreenBtn()) { <button mat-icon-button (click)="viewFullScreen()" title="Open in full screen view"><mat-icon>open_in_new</mat-icon></button> }
                    @if(showViewBtn()) { <a [href]="file().contentUrl" target="_blank" title="Open the file ina new tab">View in new tab</a> }
                </div>
            </div>

            @switch (file().contentType) {
                @case ("application/pdf") {
                    <lib-pdf [srcUrl]="url || file().contentUrl"></lib-pdf>
                }
                @default { <img [src]="file().contentUrl" [alt]="file().name"> }
            }

            <!-- Show spinner while it loads. -->
            } @else {
                <div class="flex-wrap flex-center">
                    @if(showViewBtn()) { <a [href]="file().contentUrl" class="w-100 text-center" target="_blank" title="Open the file ina new tab">View in new tab</a> }
                    <mat-spinner></mat-spinner>
                </div>
            }

        } @else {
            <!-- Show nothing... -->
        }
    
    `,
    styles: [`

        :host {
            align-items: flex-end;
        }
            
        .resource-viewer-actions {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: 100%;

            .actions-inner-container {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex: 1 auto;
                direction: rtl;
            }
        }

        mat-spinner {
            max-width: 3rem;
        }

        lib-pdf {
            height: 100%;
            width: 100%;
        }

        img {
            object-fit: contain;
            // width: 100%;
            // max-height: 100%;
            max-width: 100%;
            max-height: calc(100% - 0.5rem);
        }

    `]
})
export class ResourceViewerComponent {

    public file = input.required<Resource>();

    public showViewBtn = input<boolean>(false);

    public showFullScreenBtn = input<boolean>(false);

    private dialog = inject(MatDialog);

    public viewFullScreen() {
        const fileMapLike: Partial<FileMapEntry> = {
            type: this.file().contentType,
            serverUrl: this.file().contentUrl,
            filename: this.file().name,
        };

        this.dialog.open(FullScreenImageDialogComponent, {
            height: '95%',
            width: '95%',
            maxHeight: 'unset',
            maxWidth: 'unset',
            data: {
                file: fileMapLike,
            }
        });
    }

}
